// API 서버 주소 한 곳에서 관리.
// - 비어 있으면(기본값) 현재 접속한 도메인과 같은 origin 을 사용합니다.
//   운영 환경에서는 nginx 가 /api, /uploads, /socket.io 를 백엔드(express)로 프록시합니다.
// - 개발(npm start) 시에는 .env.development 의 REACT_APP_API_BASE 가 사용됩니다.
export const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
